export const relTime = (iso) => {
  if (!iso) return "Nunca";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "hace un momento";
  if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
  if (s < 86400) return `hace ${Math.floor(s / 3600)} h`;
  const d = Math.floor(s / 86400);
  return d < 30 ? `hace ${d} ${d === 1 ? "día" : "días"}` : `hace ${Math.floor(d / 30)} m`;
};

export const exact = (iso) => (iso ? new Date(iso).toLocaleString("es-MX", { timeZone: "America/Mexico_City", dateStyle: "medium", timeStyle: "short" }) : "—");
export const shortDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-MX", { timeZone: "America/Mexico_City", dateStyle: "medium" }) : "—");

export const roleLabel = (u) => (u.rol === "asistente" ? `Asistente de ${u.asistente_de}` : u.rol === "admin" ? "Admin" : "Dueño");
export const activLabel = (u) => (u.activado ? "Sí" : `${Math.min(u.compartibles, u.meta)} de ${u.meta}`);
export const invLabel = (i) => `${i.enviadas} / ${i.registradas} / ${i.activadas}`;
